@if (choices) {
    <div class="mb-3">
        <fieldset class="row justify-content-between">
            <div class="col-auto col-sm-6 d-flex flex-column flex-sm-row gap-2">
                @if (choices.choicePositive; as choice) {
                    <span class="choices">
                        <pace-forms-input-radio
                            [label]="choice.label"
                            [value]="choice.xmlId"
                            [name]="choice.xmlId"
                            [disabled]="disabled"
                            [ngModel]="selectedValue"
                            (ngModelChange)="onChanged($event)"
                        ></pace-forms-input-radio>
                    </span>
                }
                @if (choices.choiceNegative; as choice) {
                    <span class="choices">
                        <pace-forms-input-radio
                            [label]="choice.label"
                            [value]="choice.xmlId"
                            [name]="choice.xmlId"
                            [disabled]="disabled"
                            [ngModel]="selectedValue"
                            (ngModelChange)="onChanged($event)"
                        ></pace-forms-input-radio>
                    </span>
                }
                @if (choices.choiceNa; as choice) {
                    <span class="choices">
                        <pace-forms-input-radio
                            [label]="choice.label"
                            [value]="choice.xmlId"
                            [name]="choice.xmlId"
                            [disabled]="disabled"
                            [ngModel]="selectedValue"
                            (ngModelChange)="onChanged($event)"
                        ></pace-forms-input-radio>
                    </span>
                }
            </div>
            <div class="col-auto col-sm-6 align-self-end pe-0">
                @if ((choices.choicePositive || choices.choiceNegative || choices.choiceNa) && !disabled) {
                    <button
                        class="btn btn-link"
                        (click)="reset()"
                        translate="STANDARD_FUNCTIONAL_ELEMENT_RESET_BUTTON_LABEL"
                    ></button>
                }
            </div>
        </fieldset>
    </div>
}
